import styled from 'styled-components'
const Wrapper = styled.div`
  .top-header {
    background: var(--bg-dark);
    color: var(--text-light);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 3rem;
    flex-wrap: wrap;
}

.top-header-left img {
    width: 33px;
    height: 22px;
}

.top-header-left span i {
    font-size: 10px;
    position: relative;
    bottom: 5px;
}

.top-header-left,
.top-header-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.top-header-right {
    gap: 1.5rem;
}

.top-header-left span {
    font-size: 14px;
}

.top-header-right a {
    color: var(--text-light);
    text-decoration: none;
    font-size: 14px;
}

.top-header-right a:hover {
    text-decoration: underline;
}

.top-icons {
    display: flex;
    gap: 10px;
    align-items: center;
}

.top-icons img {
    height: 24px;
}

@media (max-width: 768px) {
    .top-header {
        flex-direction: column;
        align-items: flex-start;
        padding: 1rem;
        gap: 1rem;
    }

    .top-header-left,
    .top-header-right {
        width: 100%;
        justify-content: center;
    }

    .top-header-right {
        flex-direction: row;
        flex-wrap: wrap;
    }
}


.scroll-to-top-btn {
  position: fixed;
  bottom: 80px; 
  right: 30px;
  z-index: 9999;
  background: none;
  border: none;
  cursor: pointer;
  color: #007bff; 
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.2);
    color: #0056b3;
  }
}

 `
  export default Wrapper